// src/contexts/NotificationContext.js
import React, { createContext, useState, useEffect } from "react";
import api from "../services/api";
import i18n from "../language/i18n";

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Função para buscar as notificações
  const fetchNotifications = async () => {
    try {
      const response = await api.get("/notifications");
      setNotifications(response.data);
    } catch (err) {
      console.error("Erro ao buscar notificações:", err);
      setError(i18n.t("notification-load-error"));
    } finally {
      setLoading(false);
    }
  };

  const markNotificationsAsRead = async () => {
    try {
      await api.post("/notifications/update");
      fetchNotifications();
    } catch (err) {
      console.error("Erro ao marcar notificações como lidas:", err);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        loading,
        error,
        markNotificationsAsRead, // Disponibiliza a função para o componente
        fetchNotifications,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
